import React, { useState } from 'react';
import { createPolicy as createPolicyAPI } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';
import './_Modal.css';

const CreatePolicyModal = ({ onClose, onPolicyCreated }) => {
    const [name, setName] = useState('');
    const [text, setText] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        try {
            await createPolicyAPI({ name, text });
            setMessage('Policy created successfully.');
            onPolicyCreated();
            onClose();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Create Policy</h2>
                <form onSubmit={handleSubmit}>
                    {error && <p className="error">{error}</p>}
                    {message && <p className="message">{message}</p>}
                    <div className="form-group">
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            placeholder='Name'
                        />
                    </div>
                    <div className="form-group">
                        <textarea
                            className="policy-text-full"
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            required
                            placeholder='Text'
                        ></textarea>
                    </div>
                    <div className="actions-centered">
                        <button type="button" className="cancel-button text-button" onClick={onClose}>Cancel</button>
                        <button type="submit" className="submit-button text-button">Create</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreatePolicyModal;